import TabItem from './TabItem';
import { TabItemProps, TabItemValueProps } from './types';

export type { TabItemProps, TabItemValueProps };
export default TabItem;
